import React, { useEffect, useState} from 'react' 
import $ from 'jquery'
import '../layout/Filter.Module.css'
import '../layout/Eventos.Module.css'
import { events } from '../events';
import { Link, Route, Routes } from 'react-router-dom'
import format from 'date-fns/format'
import { useTranslation } from 'react-i18next';
import useScrollReveal from './hooks/useScrollReveal';
/****Dar um destaque para eventos futuros quando entrar na página antes de mostrar Tudo, um formulário como o formulario da tabela para
solicitar os futuros eventos*******/
function Eventos() {
  useScrollReveal(true);
  useEffect(() => {
  
  }, []);
  var targetTime;

  const ShowCountdown = (e) => {
    //var target = new Date(e).getTime();
    console.log(e);
  }

  const getFormattedDate = (dateStr) => {
    const date = new Date(dateStr);
    const parts = dateStr.split("/");
    const day = parseInt(parts[0], 10);
    return day;
  }

  const getMonth= (dateStr) => {
    var dateParts = dateStr.split("/");

    const year = parseInt(dateParts[2]);
    const month = parseInt(dateParts[1])-1;
    const day = parseInt(dateParts[0]);
    
    var dateObject = new Date(year, month, day); 
    const m = dateObject.toLocaleString('pt-PT', { month: 'short' });
    return m
  }

  const setNewTime = () => {};
  useEffect(() => {
    const interval = setInterval(() => {
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  
  useEffect(() =>{

    $(".list").on('click',function(e){
      $(".list").removeClass("active");
      $(this).addClass("active");
    })

    $('.list').on('click',function(){
      const value = $(this).attr('data-filter');
      if(value === 'all'){
        $('.itemBox').show('1000');
      }
      else{
        $('.itemBox').not('.'+value).hide('1000');
        $('.itemBox').filter('.'+value).show('1000');
      }
    });
    const interval = setInterval(() => setNewTime(), 1000);
}, [])

const { t, i18n } = useTranslation('');
  return (
    <div id='#events' className='events'>
    <section id="gallery">

    <h4 className='scroll-right'>{t('eventos.textTitle')}</h4>
    <h1 className='title_head scroll-top'>{t('navbar.eventos')}</h1>
        <div className='filter-button scroll-right'>
            <ul>
              <li className='list active' data-filter="all">{t('navbar.tudo')}</li>
              <li className='list' data-filter="2022">2022</li>
              <li className='list' data-filter="2023">2023</li>
              <li className='list' data-filter="2024">2024</li>
              <li className='list' data-filter="2025">2025</li>
            </ul>
        </div>
        <div className='all-events'>
          <div className='list-events'>
            <ul className="events-list scroll-bottom">
                {events.map((item)=>(
                    <li className={`${item.year} itemBox`} key={item.id}>
                    <div className='img-overlay'>
                      <Link to={`/evento/${item.title}`}><img src={item.imgP} width="100%" alt={item.title}/>
                        <div className="bottom-left">
                          <div className="thumbnail-info" style={{backgroundColor: 'var(--logo-bege)'}}>
                            <div className="thumbnail-date">
                              <span className="thumbnail-date-day">{getFormattedDate(item.date)}</span>
                              <span className="thumbnail-date-month">{getMonth(item.date)}</span>
                            </div>
                          </div>
                        </div>
                      <div className="badges">
                      <div className="badge top-right">
                        <div className="places text-uppercase">
                          <span>{item.city[i18n.language]}</span>
                        </div>
                      </div>
                      <div className="badge bottom-top">
                        <div className="price text-uppercase">
                            <p>{item.date}</p>
                        </div>
                      </div>
                    </div>
                    <div className="overlay-txt">
                      <div className="text">{item.title}</div>
                    </div>
                    </Link>
                    </div>
                  </li>

                ))}
            </ul> 
        </div>
        </div>
    </section>
    </div>
  )
}

export default Eventos